<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <app-left-panel-prelogin activeTab="2"></app-left-panel-prelogin>

        <!-- <app-left-panel-prelogin activeTab="2" *ngIf="!this.auth?.detailuser"></app-left-panel-prelogin> -->
        <!-- <left-panel activeTab="2" *ngIf="this.auth?.detailuser"></left-panel> -->
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <grid-row class="justify-content-center align-content-between pb-30 h-100">
                <grid-col col="12">
                    <!-- <div class="font-400 font-size-20px line-h-25">
                                            {{ "PleaseEnterIDNumber" | translate }}
                                        </div> -->
                    <div class="font-400 font-size-20px line-h-25">
                        {{ "WhatWouldLikePay" | translate }}
                    </div>
                    <!-- <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                                            {{ "YouCanProceedWithPayment" | translate }}
                                        </div> -->
                    <div class="font-400 font-size-14px color-base-400 mt-10 line-h-20">
                        {{ "YouProceedPayment" | translate }}
                    </div>

                    <div class="form-group mt-30" *ngIf="prodType == 'C'">
                        <label>
                            {{ "CardDigit" | translate }}
                        </label>
                        <div>
                            <input type="text" placeholder="•••• •••• •••• 8888" [(ngModel)]="CardDigit">
                        </div>
                    </div>
                    <div class="form-group mt-30" *ngIf="prodType == 'L'">
                        <label>
                            {{ "LOANNUMBER" | translate }}
                        </label>
                        <div>
                            <input type="text" placeholder="Please enter" [(ngModel)]="Accnum">
                        </div>
                    </div>
                </grid-col>
                <grid-col col="12">
                    <grid-row class="mt-24 mb-mobile-20">
                        <grid-col col="12">
                            <!-- <button class="btn-dft"  [disabled]="isValid()" (click)="QuickPay()">
                                                                            {{ "PAY" | translate }}
                                                                        </button> -->
                            <button class="btn-dft" [disabled]="isValid()" (click)="payCard()">
                                {{ "Next" | translate }}
                            </button>
                        </grid-col>
                        <!-- <grid-col col="12">
                            <button class="btn-dft-border mt-20" [disabled]="isValid()" (click)="MobileNumber()">
                                {{ "Inquire" | translate }}
                            </button>
                        </grid-col> -->
                        <grid-col col="12">
                        <grid-row class="justify-content-between mt-20">
                            <grid-col col="auto">
                              <button class="btn-back mt-20" (click)="back()">
                                <i class="icon-back"></i>
                              </button>
                            </grid-col>
                             <grid-col col="9">
                                <button class="btn-dft-border mt-20" [disabled]="isValid()" (click)="MobileNumber()">
                                    {{ "Inquire" | translate }}
                                </button>
                            </grid-col> 
                          </grid-row>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>



<!-- Mobile Number  Modal Open -->

<!-- <modal modalID="2" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="NEXT"
    [modalDoneButtonDisabled]="InQuireValid()" (doneButton)="this.InquirePay()">
    <div class="text-align-left">
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "PleaseEnterYourMobileNumber" | translate }}
        </div>
        <div class="form-group mt-30">
            <grid-row class="col-space-min">
                <grid-col col="12">
                    <label class="no-mark">
                        {{ "MobileNumber" | translate }}
                    </label>
                </grid-col>
                <grid-col col="3">
                    <select type="text" placeholder="+973">
                        <option value="">+973</option>
                  
                    </select>
                </grid-col>
                <grid-col col="9">
                    <div>
                        <input type="tel" placeholder="8888 8888" mask="99999999" [(ngModel)]="this.mobileno">
                    </div>
                </grid-col>
            </grid-row>
        </div>
    </div>
</modal> -->

<!-- Mobile Number Modal close  -->